import { ClientPageSectionModel } from '../../domain/models/dynamic-form-schema.model';
import { parseFormDate } from './serialize-date';

const DATE_FIELD_TYPES = ['birth-date', 'signature-date'];

/**
 * Builds the `patchValue` payload for a dynamic form from the answers returned
 * by the API. Handles both camelCase and PascalCase serialization and converts
 * date-typed answers to local Date objects so the datepicker renders the saved
 * calendar day (see {@link parseFormDate}).
 */
export function buildFormValuesFromAnswers(
    sections: ClientPageSectionModel[],
    formValue: any
): Record<string, any> {
    const dateFieldKeys = collectDateFieldKeys(sections);
    const values: Record<string, any> = {};

    const answers = (formValue?.values ?? formValue?.Values ?? []) as any[];
    for (const answer of answers) {
        const fieldName = answer.fieldName ?? answer.FieldName;
        if (!fieldName) {
            continue;
        }
        const answerValue = answer.answer ?? answer.Answer;
        values[fieldName] = dateFieldKeys.has(fieldName)
            ? parseFormDate(answerValue)
            : answerValue;
    }

    return values;
}

function collectDateFieldKeys(sections: ClientPageSectionModel[]): Set<string> {
    const keys = new Set<string>();
    for (const section of sections) {
        for (const row of section.rows) {
            for (const field of row.fields) {
                if (DATE_FIELD_TYPES.includes(field.type)) {
                    keys.add(field.key);
                }
            }
        }
    }
    return keys;
}
